module.exports = __webpack_public_path__ + "img/denmark-other-heart-diseases-female.a5432a1c.png";